import { useState } from "react";
import { organization, content, branding } from "../../config";
import axios from "axios";

export default function UnsubscribePage() {
    const [email, setEmail] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [message, setMessage] = useState("");
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!email.trim()) {
            setMessage("Email address is required");
            setSuccess(false);
            setSubmitted(true);
            return;
        }

        setSubmitting(true);
        try {
            const response = await axios.post("/api/emails/unsubscribe", {
                email: email.trim()
            });
            
            setMessage(response.data.message);
            setSuccess(true);
            setSubmitted(true);
        } catch (error) {
            setMessage("Failed to process unsubscribe request. Please try again or contact us directly.");
            setSuccess(false);
            setSubmitted(true);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div
            style={{
                fontFamily: "'Montserrat', sans-serif",
                paddingTop: "100px",
                paddingBottom: "100px",
                minHeight: "70vh",
                backgroundColor: "#F8F9FA"
            }}
        >
            <div className="container">
                <div
                    style={{
                        maxWidth: "600px",
                        margin: "0 auto",
                        backgroundColor: "white",
                        padding: "40px",
                        borderRadius: "12px",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.1)"
                    }}
                >
                    <h2
                        style={{
                            color: branding.primaryColor,
                            fontWeight: "700",
                            marginBottom: "20px",
                            textAlign: "center",
                            textTransform: "uppercase",
                            letterSpacing: "1px"
                        }}
                    >
                        Unsubscribe
                    </h2>

                    {submitted ? (
                        // Show result message
                        <div
                            style={{
                                textAlign: "center",
                                padding: "30px 20px"
                            }}
                        >
                            <div
                                style={{
                                    fontSize: "3rem",
                                    marginBottom: "20px",
                                    color: success ? "#28a745" : "#dc3545"
                                }}
                            >
                                {success ? "✓" : "✗"}
                            </div>
                            <h4
                                style={{
                                    color: success ? "#28a745" : "#dc3545",
                                    marginBottom: "15px",
                                    fontWeight: "600"
                                }}
                            >
                                {success ? "Unsubscribed Successfully" : "Error"}
                            </h4>
                            <p
                                style={{
                                    color: "#555",
                                    fontSize: "1.1rem",
                                    lineHeight: "1.6"
                                }}
                            >
                                {message}
                            </p>
                            {success && (
                                <p
                                    style={{
                                        color: "#888",
                                        fontSize: "0.9rem",
                                        marginTop: "20px"
                                    }}
                                >
                                    We're sorry to see you go. You can resubscribe at any time from our homepage.
                                </p>
                            )}
                        </div>
                    ) : (
                        // Show unsubscribe form
                        <>
                            <p
                                style={{
                                    color: "#555",
                                    fontSize: "1.1rem",
                                    lineHeight: "1.6",
                                    textAlign: "center",
                                    marginBottom: "30px"
                                }}
                            >
                                Enter your email address below to unsubscribe from all {organization.name} email lists.
                            </p>

                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label
                                        htmlFor="email"
                                        className="form-label"
                                        style={{
                                            fontWeight: "600",
                                            color: "#333"
                                        }}
                                    >
                                        Email Address
                                    </label>
                                    <input
                                        type="email"
                                        id="email"
                                        className="form-control"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                        style={{
                                            borderRadius: "8px",
                                            border: "2px solid #ddd",
                                            padding: "12px 16px",
                                            fontSize: "1rem"
                                        }}
                                        placeholder="Enter your email address"
                                    />
                                </div>

                                <button
                                    type="submit"
                                    className="btn w-100"
                                    disabled={submitting}
                                    style={{
                                        backgroundColor: branding.primaryColor,
                                        color: "white",
                                        border: "none",
                                        borderRadius: "8px",
                                        padding: "12px 20px",
                                        fontSize: "1rem",
                                        fontWeight: "600",
                                        marginTop: "10px"
                                    }}
                                >
                                    {submitting ? "Processing..." : "Unsubscribe"}
                                </button>
                            </form>

                            <div
                                style={{
                                    backgroundColor: "#f8f9fa",
                                    padding: "20px",
                                    borderRadius: "8px",
                                    marginTop: "30px",
                                    border: "1px solid #dee2e6"
                                }}
                            >
                                <h6
                                    style={{
                                        color: "#495057",
                                        fontWeight: "600",
                                        marginBottom: "10px"
                                    }}
                                >
                                    Need Help?
                                </h6>
                                <p
                                    style={{
                                        color: "#6c757d",
                                        fontSize: "0.9rem",
                                        margin: 0
                                    }}
                                >
                                    If you have trouble unsubscribing or have questions, please{" "}
                                    <a
                                        href="/contact"
                                        style={{ color: branding.primaryColor }}
                                    >
                                        contact us directly
                                    </a>.
                                </p>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
